import React, { Component } from 'react';
import { t, t1 } from 'translate';
import PropTypes from 'prop-types';
import Panel from 'components/common/forms/questions/question-panel';
import { connect } from 'react-redux';
import { types } from 'components/admin/question/schema/question-types';
import { getQuestionAnswersInfo } from 'common/question';
import isEqual from 'lodash.isequal';
import './stylesheet.scss';
import { isSmallScreen } from 'common';

import { isOEQuestion, isQuestionHaveContent } from 'common/learn/Question';
import { questionDisplayTemplates, reorderTypes } from 'configs/constants';
import { stripHTML } from 'common/utils/string';
import get from 'lodash.get';

import QuestionContent from './QuestionContent';
import QuestionBody from './QuestionBody';
import QuestionFeedback from './QuestionFeedback';
import AnswersLog from './AnswersLog';
import QuestionHint from 'components/learn/common/question-hint';

import { isShallowEqual } from 'common/utils/object';

import QuestionLearningSuggestion from './QuestionLearningSuggestion';
import {
  getQuestionTimeLeft,
  isQuestionDisabled,
} from 'common/learn/exercise/question';
import { generateHelpTextKey } from './utility';
import { isOEAdvancedLayoutType } from './open-ended/util';
import { isFormValuesDifferenceUserAnswers } from 'common/learn/Question';
import { steps } from 'common/learn/exercise';
import { isAnswerSaveSuccess } from 'components/learn/utils';
class Question extends Component {
  cssClass = 'question-display';

  constructor(props) {
    super(props);
    this.state = {
      userAnswers: null,
      highlights: [],
      isHandleChooseAnswer: false, //Trường này để phân biệt việc save user answer do user chọn & do repopulate prev user answers,
      // phục vụ việc save lại answers log trong bảng take
      showHints: false,
      currentHint: -1,
    };
  }

  handleHintClose = () => {
    this.setState({
      showHint: false,
    });
  };

  handleHintChange = () => {
    const { question = {} } = this.props;
    const { hints = [] } = question;

    const { currentHint } = this.state;
    const newCurrentHint =
      currentHint === hints.length - 1 ? 0 : currentHint + 1;

    this.setState({
      currentHint: newCurrentHint,
      showHint: true,
    });
  };

  getCurrentHintText = () => {
    const { currentHint } = this.state;
    if (currentHint < 0) {
      return '';
    }

    const { question = {} } = this.props;
    const { hints = [] } = question;
    const hint = get(hints, `[${currentHint}].name`, '');

    if (!hint) {
      return '';
    }

    return `${t1(
      'hint_time_%s',
      `${currentHint + 1}/${hints.length}`,
    )}: ${hint}`;
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return !(
      nextState === this.state &&
      isShallowEqual(nextProps, this.props, ['question']) &&
      isEqual(nextProps.question, this.props.question)
    );
  }

  componentDidMount() {
    const { defaultAnswers } = this.props;
    this.resetDefaultAnswer(defaultAnswers);
  }

  componentWillReceiveProps(nextProps) {
    const { defaultAnswers } = this.props;
    if (nextProps.defaultAnswers !== defaultAnswers) {
      this.resetDefaultAnswer(nextProps.defaultAnswers);
    }

    const oldQuestion = this.props.question;
    const question = nextProps.question;
    if (question.iid !== oldQuestion.iid) {
      this.resetDefaultAnswer(defaultAnswers);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { question, onChange } = this.props;

    if (
      prevProps.question !== question &&
      this.hasFullQuestionInfo() &&
      !this.state.userAnswers
    ) {
      this.setUserAnswers(this.getDefaultUserAnswer());
    }

    if (
      typeof onChange === 'function' &&
      !isEqual(prevState.userAnswers, this.state.userAnswers)
    ) {
      onChange(this.state.userAnswers);
    }

    // only check answer for question in current questions list
    if (
      question &&
      (this.shouldCheckAnswerWhenUpdateAnswer(
        prevState.userAnswers,
        this.state.userAnswers,
      ) ||
        prevProps.shouldShowKeyWhenShowAnswer !==
          this.props.shouldShowKeyWhenShowAnswer)
    ) {
      this.checkAnswer();
    }
  }

  shouldCheckAnswerWhenUpdateAnswer = (prevAnswers, nextAnswers) => {
    const { question } = this.props;
    const isEqualAnswer = isEqual(prevAnswers, nextAnswers);
    if (question && isOEQuestion(question)) {
      return (
        prevAnswers &&
        isFormValuesDifferenceUserAnswers(prevAnswers, nextAnswers, question)
      );
    }

    return !isEqualAnswer;
  };

  resetDefaultAnswer = (defaultAnswers) => {
    if (defaultAnswers) {
      this.setUserAnswers(defaultAnswers);
    } else if (this.hasFullQuestionInfo()) {
      this.setUserAnswers(this.getDefaultUserAnswer());
    }
  };

  getDefaultUserAnswer() {
    const { question } = this.props;

    switch (question.type) {
      case types.TYPE_REORDER: {
        if (question.reorders && question.reorder_type === reorderTypes.BOX) {
          return isSmallScreen
            ? question.reorders.map((item) => [item.id])
            : [];
        }

        if (question.reorders && question.reorder_type !== reorderTypes.WORD) {
          return question.reorders.map((item) => [item.id]);
        }

        return [];
      }

      case types.TYPE_LIKERT: {
        const { likert_questions = [] } = question;
        return likert_questions.map(() => []);
      }
      default: {
        return [];
      }
    }
  }

  hasFullQuestionInfo = () => {
    const { question } = this.props;
    return typeof question.type !== 'undefined';
  };

  _isCorrect = () => this.state.isCorrect;

  _shouldShowAnswer = () => {
    const { shouldShowAnswerWhenHasResult, question } = this.props;

    if (
      shouldShowAnswerWhenHasResult &&
      parseInt(question.type) == types.TYPE_OPEN_ENDED
    )
      return true;

    const isCorrect = this._isCorrect();
    const hasResult = isCorrect === true || isCorrect === false;
    return shouldShowAnswerWhenHasResult && hasResult;
  };

  getHighlights = () => (this._shouldShowAnswer() ? this.state.highlights : []);

  setUserAnswers = (newUserAnswers) => {
    this.setState({
      userAnswers: newUserAnswers,
    });
  };

  handleChooseAnswer = (userAnswers) => {
    this.setState({
      isHandleChooseAnswer: true,
    });

    this.setState({ userAnswers });
    this.resetHighlights();
  };

  getItemByIndex = (index) => {
    const { question } = this.props;
    const { mc_answers } = question;

    let localItem = {};
    mc_answers.forEach((optionIndex, i) => {
      if (optionIndex === index) {
        localItem = mc_answers[i];
      }
    });

    return localItem;
  };

  getValueOfItem = (item, index, value) => {
    let itemValue;
    if (value && value === '@index') {
      itemValue = index;
    } else {
      itemValue = !value ? item : item[value];
    }

    return itemValue;
  };

  getHighlightsClass = (dataValue) => {
    const highlights = this.getHighlights();
    if (!highlights) {
      return '';
    }

    let className = '';
    highlights.forEach((highlightItem) => {
      if (highlightItem.value === dataValue) {
        className = highlightItem.className;
      }
    });

    return className;
  };

  resetHighlights = () => {
    this.setState({
      highlights: [],
    });
  };

  checkAnswer = () => {
    const {
      question,
      highlightsClass,
      onCheckAnswerFinish,
      shouldShowKeyWhenShowAnswer,
    } = this.props;
    const { userAnswers } = this.state;
    let result = getQuestionAnswersInfo(
      question,
      userAnswers,
      highlightsClass,
      shouldShowKeyWhenShowAnswer,
    );

    this.setState({
      highlights: result.highlights,
      isCorrect: result.take && result.take.isCorrect,
    });

    if (onCheckAnswerFinish) {
      let take = result.take;
      if (this.state.isHandleChooseAnswer) {
        take.ts = parseInt(Date.now() / 1000, 10);
      }
      onCheckAnswerFinish(take);
      this.setState({ isHandleChooseAnswer: false });
    }
  };

  handleQuestionDone = () => {
    const { onQuestionDone } = this.props;
    if (typeof onQuestionDone === 'function') {
      onQuestionDone();
    }
  };

  getHeaderText = (displayTemplate, question) => {
    switch (displayTemplate) {
      case questionDisplayTemplates.CONTENT_DISPLAYED_INSIDE_HEADER: {
        return stripHTML(get(question, 'content', ''));
      }
      default: {
        const title = get(question, 'title');
        if (title) {
          return title;
        }

        return t1(generateHelpTextKey(get(question, 'type')));
      }
    }
  };

  getDisplayTemplate = () => {
    // if ([types.TYPE_END_INTRODUCTION, types.TYPE_INTRODUCTION, types.TYPE_INLINE].includes(get(this.props, 'question.type'))) {
    if (types.TYPE_INLINE == get(this.props, 'question.type')) {
      return questionDisplayTemplates.DEFAULT;
    }
    let displayTemplate = get(this.props, 'displayTemplate');
    if (
      !displayTemplate ||
      displayTemplate === questionDisplayTemplates.DEFAULT
    ) {
      displayTemplate = get(this.props, 'question.display_template');
    }
    return displayTemplate;
  };

  render() {
    const {
      shouldShowKeyWhenShowAnswer,
      instantShowFeedback,
      isContentAudioControllable,
      isContentAudiosControllable,
      isContentAudiosPlaying,
      isTicked,
      onBookMarkAreaClick,
      onContentAudioEnded,
      onContentAudioPlay,
      onContentAudiosEnded,
      shouldShowQuestionHelpText,
      shouldShowQuestionNumber,
      shouldShowQuestionHeader,
      answersAndAnswersLog,
      shouldShowQuestionIdWhenShowAnswer,
      shouldShowQuestionLearningSuggestionWhenShowAnswer,
      question,
      isSurvey,
      course,
      inlineExercise,
      saveTakeSuccess,
      exerciseStep,
    } = this.props;

    if (!question || typeof question.type === 'undefined') {
      return null;
    }

    const shouldShowAnswer = this._shouldShowAnswer();
    const highlights = this.getHighlights();
    const isCorrect = this._isCorrect();

    const props = {
      ...this.props,
      highlights,
      setUserAnswers: this.setUserAnswers,
      userAnswers: this.state.userAnswers,
      handleChooseAnswer: this.handleChooseAnswer,
      getItemByIndex: this.getItemByIndex,
      checkAnswer: this.checkAnswer,
      getHighlightsClass: this.getHighlightsClass,
      getValueOfItem: this.getValueOfItem,
      resetHighlights: this.resetHighlights,
      onChange: this.handleQuestionDone,
      // when show answer, all inputs are disabled
      disabled:
        isQuestionDisabled(question) ||
        shouldShowAnswer ||
        exerciseStep === steps.REVIEW,
      // this prop (shouldShowKey) is used by answer reorder and matching pair question to show answer when review, reconsider to change this in the future
      shouldShowKey:
        (shouldShowAnswer || exerciseStep === steps.REVIEW) &&
        shouldShowKeyWhenShowAnswer,
      shouldShowAnswer: shouldShowAnswer || exerciseStep === steps.REVIEW,
    };
    const haveContent = isQuestionHaveContent(question);
    const displayTemplate = this.getDisplayTemplate();

    const { answersLog } = answersAndAnswersLog || {};

    // special exercise
    const isAdvancedLayoutType = isOEAdvancedLayoutType(question);
    const currentHintText = this.getCurrentHintText();

    const { showHint } = this.state;

    const shouldShowTitle =
      inlineExercise || (!isAdvancedLayoutType && shouldShowQuestionHelpText);
    const shouldShowNumber =
      inlineExercise || (!isAdvancedLayoutType && shouldShowQuestionNumber);
    const shouldShowQuestionId =
      !isAdvancedLayoutType &&
      shouldShowAnswer &&
      shouldShowQuestionIdWhenShowAnswer;
    const shouldShowOEQuestionFeedback =
      isOEQuestion(get(question, 'type')) &&
      isAnswerSaveSuccess(saveTakeSuccess, question.id);
    const shouldShowFeedback = shouldShowAnswer && instantShowFeedback;

    const questionTitle =
      inlineExercise || !isAdvancedLayoutType
        ? this.getHeaderText(displayTemplate, question)
        : '';

    return (
      <Panel
        shouldShowTitle={shouldShowTitle}
        shouldShowNumber={shouldShowNumber}
        shouldShowHeader={shouldShowQuestionHeader}
        title={questionTitle}
        onBookMarkAreaClick={!isAdvancedLayoutType && onBookMarkAreaClick}
        isTicked={isTicked}
        number={question.number}
        question={question}
        questionTimeLeftInSeconds={getQuestionTimeLeft(question)}
        inlineExercise={inlineExercise}
        handleHintChange={this.handleHintChange}
      >
        {shouldShowQuestionId && (
          <div>
            {t('question_id')}: {question.id}
          </div>
        )}
        {haveContent && (
          <QuestionContent
            isAudioControllable={isContentAudioControllable}
            isAudiosControllable={isContentAudiosControllable}
            isAudiosPlaying={isContentAudiosPlaying}
            onAudiosEnded={onContentAudiosEnded}
            onAudioPlay={onContentAudioPlay}
            onAudioEnded={onContentAudioEnded}
            question={question}
            displayTemplate={displayTemplate}
            isSurvey={isSurvey}
            handleHintClose={this.handleHintClose}
            currentHint={this.getCurrentHintText()}
            showHint={showHint}
          />
        )}

        {currentHintText && showHint && (
          <QuestionHint
            hint={currentHintText}
            handleClose={this.handleHintClose}
          />
        )}

        {isOEQuestion(question) && shouldShowOEQuestionFeedback && (
          <QuestionFeedback question={question} isCorrect={true} />
        )}

        <QuestionBody question={question} {...props} course={course} />

        {!isOEQuestion(question) && shouldShowFeedback && (
          <QuestionFeedback question={question} isCorrect={isCorrect} />
        )}

        {!isAdvancedLayoutType && answersLog && (
          <AnswersLog answersLog={answersLog} question={question} />
        )}

        {shouldShowAnswer &&
        shouldShowQuestionLearningSuggestionWhenShowAnswer &&
        !isCorrect ? (
          <QuestionLearningSuggestion
            className={`${this.cssClass}__learning-suggestion`}
            question={question}
          />
        ) : null}
      </Panel>
    );
  }
}

Question.propTypes = {
  shouldShowKeyWhenShowAnswer: PropTypes.bool,
  instantShowFeedback: PropTypes.bool,
  isContentAudioControllable: PropTypes.func,
  isContentAudiosControllable: PropTypes.bool,
  isContentAudiosPlaying: PropTypes.bool,
  isTicked: PropTypes.bool,
  onBookMarkAreaClick: PropTypes.func,
  onContentAudioEnded: PropTypes.func,
  onContentAudioPlay: PropTypes.func,
  onContentAudiosEnded: PropTypes.func,
  onQuestionDone: PropTypes.func,
  onCheckAnswerFinish: PropTypes.func,
  question: PropTypes.shape(),
  shouldShowAnswerWhenHasResult: PropTypes.bool,
  shouldShowQuestionHeader: PropTypes.bool,
  shouldShowQuestionHelpText: PropTypes.bool,
  shouldShowQuestionNumber: PropTypes.bool,
  shouldShowScoreWhenShowAnswer: PropTypes.bool,
  shouldShowQuestionIdWhenShowAnswer: PropTypes.bool,
  shouldShowQuestionLearningSuggestionWhenShowAnswer: PropTypes.bool,
};

Question.defaultProps = {
  shouldShowKeyWhenShowAnswer: false,
  instantShowFeedback: true,
  isContentAudioControllable: () => true,
  isContentAudiosControllable: true,
  isContentAudiosPlaying: false,
  isTicked: false,
  onBookMarkAreaClick: null,
  onContentAudioEnded: null,
  onContentAudioPlay: null,
  onContentAudiosEnded: null,
  onQuestionDone: null,
  onCheckAnswerFinish: null,
  question: null,
  shouldShowAnswerWhenHasResult: false,
  shouldShowQuestionHeader: true,
  shouldShowQuestionHelpText: true,
  shouldShowQuestionNumber: true,
  shouldShowScoreWhenShowAnswer: true,
  shouldShowQuestionIdWhenShowAnswer: false,
  shouldShowQuestionLearningSuggestionWhenShowAnswer: false,
};

const mapStateToProps = (state, props) => {
  return {
    question: props.question || state.tree[props.iid],
    answersAndAnswersLog: get(state, 'learn.answersLog'),
  };
};

export default connect(mapStateToProps)(Question);
